import { gql } from "@/gql/__generated__";
import { AppSessionsQuery } from "@/gql/__generated__/graphql";
import { ArrayElement } from "@/lib/ts-helpers/ArrayElement";
import { useQuery } from "@apollo/client";

const APP_SESSIONS = gql(`
  query appSessions($after: ID, $first: Int, $filter: AppSessionsFilterInput){
    appSessions(after: $after, first: $first, filter: $filter) {
       __typename
       edges {
        __typename
        cursor
        node {
          __typename
          id
          app {
            __typename
            id
            displayName
          }
          ownerOrganization
          userId
          userEmail
          accessType
          startTime
          endTime
        }
       }
       pageInfo {
        __typename
        hasNextPage
        startCursor
        endCursor
       }
    }
  }
`);

export type AppSession = ArrayElement<AppSessionsQuery["appSessions"]["edges"]>;
export type AppSessionApp = AppSession["node"]["app"];
export type AppSessionsQueryResult = typeof useAppSessions;

export function useAppSessions() {
  const { data, ...rest } = useQuery(APP_SESSIONS);

  const appSessions = data?.appSessions || undefined;

  return { ...rest, data: appSessions };
}
